const billingSettingsRequests = {
  getBillingSettingsRequest: () => ({
    url: `tenant-service/api/config/billingsettings`,
    method: 'get',
  }),
  getSessionApprovalSettingsRequest: () => ({
    url: `api/config/sessionApprovalSettings`,
    method: 'get',
  }),
}

export default billingSettingsRequests
